import { render, staticRenderFns } from "./SuperAdminUserMenu.vue?vue&type=template&id=087c36f2&"
import script from "./SuperAdminUserMenu.vue?vue&type=script&lang=js&"
export * from "./SuperAdminUserMenu.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminUserMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports